import { fetchContactList } from './fetchContactList';
import { sendSumoLog } from './sumoLogger';
import { updateError } from '../../store';
import { NOTIF_USER_KEYS } from '../../components/NotificationComponents/constants';

export const postNotifUser = async (token, fullNotifUserBody, dispatch) => {
  const requestUrl = encodeURI(
    `https://${
      process.env.REACT_APP_API_SUBDOMAIN
    }.pge-811.com/ticket-notification/user/${
      fullNotifUserBody[NOTIF_USER_KEYS.USER_ID]
    }`
  );
  const headers = new Headers({
    Authorization: `Bearer ${token}`,
    'Content-Type': 'application/json',
  });

  try {
    const data = await fetch(requestUrl, {
      method: 'POST',
      headers,
      body: JSON.stringify(fullNotifUserBody),
    });
    const body = await data.json();

    if (!data.ok) {
      throw {
        message: `Failed to create user ${
          fullNotifUserBody[NOTIF_USER_KEYS.USER_ID]
        } with status: ${data.status} and message: ${body.message}`,
        code: data.status,
      };
    }

    fetchContactList(token, dispatch);
  } catch (error) {
    const isInternalError = error instanceof Error;
    const errorMessage = isInternalError ? error.toString() : error.message;

    sendSumoLog(
      'postNotifUser',
      errorMessage,
      isInternalError ? 500 : error.code,
      dispatch,
      false
    );
    updateError(error, dispatch);
  }
};
